import React from 'react';
import * as S from './styles';

type Props = {
  children: React.ReactNode;
};

export const Card = ({ children }: Props) => {
  return (
    <S.Card container justifyContent='center'>
      {children}
    </S.Card>
  );
};
